import React from 'react';
import '../template-file-css/document-file-template.css';


export const AFHS_IncidentReport = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='AFHS_IncidentReport' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Service code box needed:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbServiceCode_1' name='rbServiceCode' className='add-only' value='1' /> Submitted to ED </td>
                        <td className='w-250'>
                            <input type='radio' id='rbServiceCode_2' name='rbServiceCode' className='add-only' value='2' /> Received by ED</td>
                        <td className='w-250'>
                            <input type='radio' id='rbServiceCode_3' name='rbServiceCode' className='add-only' value='3' /> CorrectionNeeded immediately
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbServiceCode_4' name='rbServiceCode' className='add-only' value='4' /> Approved/Accepted by ED</td>
                        <td className='w-250'>
                            <input type='radio' id='rbServiceCode_5' name='rbServiceCode' className='add-only' value='5' /> Uploaded into Image</td>
                        <td className='w-250'>
                            <input type='radio' id='rbServiceCode_6' name='rbServiceCode' className='add-only' value='6' /> Accepted by DBHDD</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbServiceCode_7' name='rbServiceCode' className='add-only' value='7' />  DBHDD Correction needed</td>
                        <td className='w-250'>
                            <input type='radio' id='rbServiceCode_8' name='rbServiceCode' className='add-only' value='8' /> Denied</td>
                        <td className='w-250'>
                            &nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'><center><h3>APEX Family Healthcare <br />
                    INCIDENT REPORT</h3></center>
                    <b>Instructions:</b> Death reports must be submitted within 1 hour of notification and staff with Executive Director. No exceptions.
                    All other reports must submit within 24 hours of incident. All corrections must be addressed immediately</p>



                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Incident Date:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Time:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Location:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='date' id='txtIncidentDate' name='txtIncidentDate' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='time' id='txttime' name='txttime' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtLocation' name='txtLocation' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><center><h4><b>Persons Involved:</b></h4></center></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Person Served: PS1:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date Of Birth</span></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPersonServed' name='txtPersonServed' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='date' id='txtDateOfBirth_1' name='txtDateOfBirth_1' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Person Served: PS2:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date Of Birth</span></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPersonServed_1' name='txtPersonServed_1' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='date' id='txtDateOfBirth_2' name='txt_DateOfBirth2' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Staff: S1:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Position:</span></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtStaff_1' name='txtStaff_1' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtPosition_1' name='txtPosition_1' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Staff: S2:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Position:</span></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtStaff_1' name='txtStaff_1' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtPosition_2' name='txtPosition_2' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Visitor: W1:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Relationship</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtVisitor' name='txtVisitor' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtRelationship' name='txtRelationship' className='add-only' /></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Type of Incident:</span>
                            <span className='small'>(Place PS1, PS2, S1, S2, W1
                                by the type of incident)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_1' name='cbTypeOfIncident_1' className='add-only' value='UnexplainedDeath' /> Unexplained Death</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_2' name='cbTypeOfIncident_2' className='add-only' value='NaturalDeath' /> Natural Death</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_3' name='cbTypeOfIncident_3' className='add-only' value='AccidentalDeath' /> Accidental Death</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_4' name='cbTypeOfIncident_4' className='add-only' value='Suicide' /> Suicide</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_5' name='cbTypeOfIncident_5' className='add-only' value='SuicideAttempt' /> Suicide Attempt</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_6' name='cbTypeOfIncident_6' className='add-only' value='ConsumerSelfAbuse' /> Consumer Self Abuse</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_7' name='cbTypeOfIncident_7' className='add-only' value='ConsumerInjury' /> Consumer Injury</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_8' name='cbTypeOfIncident_8' className='add-only' value='ConsumerFall' /> Consumer Fall </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_9' name='cbTypeOfIncident_9' className='add-only' value='VisitorInjury' /> Visitor Injury</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_10' name='cbTypeOfIncident_10' className='add-only' value='VisitorFall' /> Visitor Fall</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_11' name='cbTypeOfIncident_11' className='add-only' value='AssaultiveBehavior' /> Assaultive Behavior</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_12' name='cbTypeOfIncident_12' className='add-only' value='AllegSexualActivity' />  Alleg Sexual Activity</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_13' name='cbTypeOfIncident_13' className='add-only' value='AWOL' /> AWOL</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_14' name='cbTypeOfIncident_14' className='add-only' value='AWOLReturned' /> AWOL Returned</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_9' name='cbTypeOfIncident_9' className='add-only' value='MedicationIncident' /> Medication Incident</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_15' name='cbTypeOfIncident_15' className='add-only' value='AdverseMedicationReaction' /> Adverse Medication Reaction</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_16' name='cbTypeOfIncident_16' className='add-only' value='MedicalEmergency' /> Medical Emergency</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_17' name='cbTypeOfIncident_17' className='add-only' value='AllegConsumerAbuse' />  Alleg Consumer Abuse</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_18' name='cbTypeOfIncident_18' className='add-only' value='AllegNeglect' /> Alleg Neglect</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_19' name='cbTypeOfIncident_19' className='add-only' value='AllegSexualAbuse' /> Alleg Sexual Abuse</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_20' name='cbTypeOfIncident_20' className='add-only' value='AllegCriminalActivity' /> Alleg Criminal Activity</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_21' name='cbTypeOfIncident_21' className='add-only' value='StaffInjury' /> Staff Injury</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_22' name='cbTypeOfIncident_22' className='add-only' value='StaffFall' /> Staff Fall</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_23' name='cbTypeOfIncident_23' className='add-only' value='PropertyDamage' /> Property Damage</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_24' name='cbTypeOfIncident_24' className='add-only' value='Fire' /> Fire</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_25' name='cbTypeOfIncident_25' className='add-only' value='MedicationError' /> Medication Error</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_26' name='cbTypeOfIncident_26' className='add-only' value='FireAlarm' /> Fire Alarm</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_27' name='cbTypeOfIncident_27' className='add-only' value='InfectiousDisease' /> Infectious Disease</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_28' name='cbTypeOfIncident_28' className='add-only' value='ContrabandLocated' /> Contraband Located</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_29' name='cbTypeOfIncident_29' className='add-only' value='VehicleAccident' /> Vehicle Accident</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_30' name='cbTypeOfIncident_30' className='add-only' value='PhysicianErrors' /> Physician's Order Errors</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeOfIncident_31' name='cbTypeOfIncident_31' className='add-only' value='Restraint' /> Restraint</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTypeOfIncident_31' name='cbTypeOfIncident_31' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtOther' name='txtOther' className='add-only w-250 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Did injury require: (Check one)
                            </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbDidInjuryRequire_1' name='rbDidInjuryRequire' className='add-only' value='OffMedicalCare' /> Off-site medical care</td>
                        <td className='w-375'>
                            <input type='radio' id='rbDidInjuryRequire_2' name='rbDidInjuryRequire' className='add-only' value='PhysicianNurseAttention' /> Physician or Nurse on-site attention</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbDidInjuryRequire_3' name='rbDidInjuryRequire' className='add-only' value=' FirstAidCare' /> First aid-care</td>
                        <td className='w-375'>
                            <input type='radio' id='rbDidInjuryRequire_4' name='rbDidInjuryRequire' className='add-only' value='NoCare' /> No care</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Were Universal Precautions Used?
                            </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbWereUniversalPrecautinsUsed_Yes' name='rbWereUniversalPrecautinsUsed' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbWereUniversalPrecautinsUsed_No' name='rbWereUniversalPrecautinsUsed' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbWereUniversalPrecautinsUsed_Na' name='rbWereUniversalPrecautinsUsed' className='add-only' value='NA' /> N/A</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If staff injury, was HR notified?
                            </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbIfStaffInjuryWasNotified_Yes' name='rbIfStaffInjuryWasNotified' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbIfStaffInjuryWasNotified_No' name='rbIfStaffInjuryWasNotified' className='add-only' value='No' /> No
                        </td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Indicate attached documents: (Check)
                            </span></td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIndicateAttachedDocuments_1' name='cbIndicateAttachedDocuments_1' className='add-only' value='RefusalMedicalCare' /> Refusal of Medical Care</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIndicateAttachedDocuments_2' name='cbIndicateAttachedDocuments_2' className='add-only' value='ProgressNotes' /> Progress Notes</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIndicateAttachedDocuments_3' name='cbIndicateAttachedDocuments_3' className='add-only' value='MedicationErrorReport' /> Medication Error Report</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIndicateAttachedDocuments_4' name='cbIndicateAttachedDocuments_4' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtOther_1' name='txtOther_1' className='add-only w-250 custom-add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>CIRs are not to be noted in client chart.</p>

                <p className='w-750'><span className='eleHeader'>QM Use Only:</span>
                    <input type='text' id='txtUseOnly' name='txtUseOnly' className='add-only' /></p>

                <p className='w-750'><span className='eleHeader'>Date CIR report was received:</span>
                    <input type='date' id='txtDateReportWasReceived' name='txtDateReportWasReceived' className='add-only' /></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Was follow-up required:
                            </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbWasFollowUpRequired_Yes' name='rbWasFollowUpRequired' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbWasFollowUpRequired_No' name='rbWasFollowUpRequired' className='add-only' value='No' /> No
                        </td>

                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Incident Description: (Facts only: what, when, who, how)</span>
                    <textarea id='txtIncidentDescription' name='txtIncidentDescription' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Immediate Action Taken:</span>
                    <textarea id='txtImmediateActionTaken' name='txtImmediateActionTaken' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Pertinent Consumer and/or Other Information: (Diagnosis, Medications)</span>
                    <textarea id='txtPertinentConsumerOther' name='txtPertinentConsumerOther' className='add-only'></textarea></p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Report prepared by signature from Notenetic</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Supervisors Comments:</span>
                    <textarea id='txtSupervisorsComments' name='txtSupervisorsComments' className='add-only'></textarea></p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Supervisor's Signature</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>








            </div>
        </form>

    )
}   